import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
} from 'react-router'

import PrivateRoutes from './private.routes'
import PublicRoutes from './public.routes'
import { RootLayout } from './RootLayout'

export const router = createBrowserRouter(
  createRoutesFromElements(
    <Route element={<RootLayout />}>
      {PublicRoutes}
      {PrivateRoutes}
    </Route>
  )
)
